import { get, post, put, patch } from "../Config"

export function SearchLanguageSetting({ params = {}, lang }) {
  return get({ url: `/v1/admin/language-setting`, params, lang })
}
export function GetLanguageSettingById({ id, lang }) {
  return get({ url: `/v1/admin/language-setting/${id}`, lang })
}
export function CreateLanguageSetting({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/language-setting`, params, data, lang })
}
export function UpdateLanguageSetting({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/language-setting/${id}`, params, data, lang })
}
export function PatchLanguageSetting({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/language-setting/${id}`, params, data, lang })
}
export function DeleteLanguageSetting({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/language-setting/mutiDelete`, params, data, lang })
}
